import Home from "./Home.vue";
import PrimeVue from 'primevue/config';

class EinvoiceRequest {
    constructor(wrapper, customer_session_id) {
        this.$wrapper = $(wrapper);
        this.customer_session_id = customer_session_id;
        this.make_body();
    }
    make_body() {
        const me = this;
        if (this.$wrapper.get(0).__vue_app__) {
            this.$wrapper.get(0).__vue_app__.unmount();
        }
        Vue.use(PrimeVue);
        this.$component = new Vue({
			el: this.$wrapper.get(0),
			data() {
				return {};
			},
			render(h) {
				return h(Home, { props: {
                    customer_session_id: me.customer_session_id,
                } });
			},
		});
    }
};

frappe.provide("myinvois.app");
myinvois.app.einvoice_request = EinvoiceRequest;
export default EinvoiceRequest;